import apis from "../../config/apis.json";
import { getAccessToken } from "../msal";
import { IPublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import {
  IGetUserPermissionsRequest,
  IUserPermission,
} from "./interfaces";

/** Retrieves permissions for the current user.
 *
 * @param instance The MSAL client instance.
 * @param request The request.
 * @returns The list of user permissions.
 */
export async function getUserPermissions(instance: IPublicClientApplication, request: IGetUserPermissionsRequest): Promise<IUserPermission[] | undefined> {
  if (!request.userId) {
    return;
  }

  const { baseUrl, scope } = apis.security;

  const requestUrl = `${baseUrl}/users/${request.userId}/permissions?app_id=${request.appId}`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.get(
    requestUrl, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    }
  );

  return result.data;
}

/** Retrieves permissions for the current user.
 *
 * @param accessToken The security service access token.
 * @param request The request.
 * @returns The list of user permissions.
 */
export async function getUserPermissionsWithToken(accessToken: string, request: IGetUserPermissionsRequest): Promise<IUserPermission[]> {
  const { baseUrl } = apis.security;

  const requestUrl = `${baseUrl}/users/${request.userId}/permissions?app_id=${request.appId}`;

  const result = await axios.get(
    requestUrl, {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    });

  return result.data;
}

